module.exports = __webpack_public_path__ + "img/0S6A0040.b390a9bc.jpg";